module.exports = __webpack_public_path__ + "media/components/country-flag/static/pl-2378aad3ec9317bac42f8475cb134716.svg";